<template>
<div  class="page">
  <Header title="订单详情" />
  <div>
    <van-tabs v-model="active" @click="handleClick">
      <van-tab v-for="(item,index) of historyLogisticsList" :title="index===0?'当前物流':`第${index}次物流`" :key="index" :name="index">

         <div class="item-info-box">
            <div class="item-info">
              <div class="item-info-title">物流状态:</div>
              <div class="item-info-detail">快递公司：{{item.logisticsCompanyName}}</div>
              <div class="item-info-detail">快递单号：{{item.logisticsNumber}}</div>
            </div>
        </div>
        <div class="express-address-box" >
          <div class="express-address" v-for="(item,index) in billList"  :key="item.remark">
            <div class="express-address-icon">
                <img class="express-circle-icon" :src="$getImgUrl('/img/wx-app/express-circle-current-icon.png')" alt="">
                <img :class="{'express-line-icon':true,'last-express-line-icon': index == (billList.length - 1)}"  :src="$getImgUrl('/img/wx-app/express-line-icon.png')" alt="">
            </div>
            <div class="pull-left">
                <div class="express-address-txt">{{item.desc}}</div>
                <div class="express-address-time">{{parseTime(item.time,'{y}-{m}-{d} {h}:{i}:{s}')}}</div>
                <div class="express-address-time" v-if="item.remark != ''">备注：{{item.remark}}</div>
            </div>
          </div>

          <div v-if="billList.length===0" class="no-logistics">暂无物流信息</div>
        </div>

      </van-tab>
    </van-tabs>
  </div>

</div>

</template>

<script>
import wxAppApi from '@/api/wx-app'
import { commonUtils } from '@/utils/common'
import Header from '@/components/header'
export default {
  data () {
    return {
      active: 0,
      orderInfo: {},
      historyLogisticsList: [],
      billList: []
    }
  },
  components: {
    Header
  },
  created () {
    let orderId = this.$route.query.orderId
    let params = {
      orderId
    }
    wxAppApi.queryItemInfo(params).then(res => {
      if (res.data.resultCode === '0') {
        this.orderInfo = res.data.resultData.orderInfo
        let logistics = {}
        logistics.logisticsNumber = this.orderInfo.baseInfo.logisticsNumber || ''
        logistics.logisticsType = this.orderInfo.baseInfo.logisticsType || ''
        logistics.logisticsCompany = this.orderInfo.baseInfo.logisticsCompany || ''
        logistics.logisticsCompanyName = this.orderInfo.baseInfo.logisticsCompanyName || ''
        logistics.finishDate = this.orderInfo.baseInfo.finishDate || ''
        this.historyLogisticsList.push(logistics)
        if (this.orderInfo.historyLogisticsList.length !== 0) {
          this.historyLogisticsList = this.historyLogisticsList.concat(this.orderInfo.historyLogisticsList)
        }
        this.getLogisticsInfo(this.historyLogisticsList[0].logisticsNumber, this.historyLogisticsList[0].logisticsCompany)
        // this.getLogisticsInfo('112221', '222222')
      }
    })
  },
  methods: {
    parseTime: commonUtils.parseTime,
    handleClick () {
      this.getLogisticsInfo(this.historyLogisticsList[this.active].logisticsNumber, this.historyLogisticsList[this.active].logisticsCompany)
      // this.getLogisticsInfo('112221', '222222')
    },
    getLogisticsInfo (logisticsNumber, logisticsCompany) {
      this.billList = []
      let params = {
        searchNumber: logisticsNumber,
        logisticsCompany
        // searchNumber: 112221,
        // logisticsCompany: 111111
      }
      wxAppApi.queryLogisticsList(params).then((res) => {
        if (res.data.resultCode === '0') {
          this.billList = res.data.resultData.billList || []
        }
      })
    }
  }
}
</script>
<style scoped>
.item-info{
  width: 100%;
  height: 70px;
  background-color: white;
  margin-top: 15px;
}
.item-info{
  width: calc(100% - 40px);
  padding:10px 20px;
}
.item-info-title{
  font-size: 16px;
  line-height: 30px;
}
.item-info-detail{
  color: rgb(99, 99, 99);
  line-height: 20px;
}
.express-address-box{
  margin-top: 10px;
  width: 100%;
  background-color: white;
}
.express-address{
  display: flex;
  position: relative;
}
.express-address-icon{
  width: 60px;
}
.express-circle-icon{
  width: 24px;
  position: relative;
  left: 22px;
  top: -50px;
  z-index: 10;
}
.express-line-icon{
  height: 95px;
  position: relative;
  top: 30px;
}
.last-express-line-icon{
  visibility: hidden;
}
.pull-left{
  margin-top: 20px;
  color: rgb(83, 83, 83);
}
.no-logistics{
  padding: 50px 0;
  text-align: center;
  color: rgb(83, 83, 83);
}
</style>
